import styled from '@emotion/styled';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import ItemThumbnail from 'src/components/ItemInventory/ItemThumbnail';
import type { ItemDetail } from 'src/types/itemInventory';
import { languageDateLocaleMap } from 'src/utils/date';
import { getLocale } from 'src/utils/language';
import { ItemLeftWrapper, ItemTitle, ThumbnailWrapper } from './common';
interface Props {
  item: ItemDetail;
  useCountLeftBadge?: JSX.Element;
}
const Base = styled.div`
  display: flex;
  align-items: center;
`;
const Thumbnail = styled(ThumbnailWrapper)`
  width: 28px;
  height: 28px;
`;
const ItemLabel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const ItemUseDays = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const ItemRow: React.FC<Props> = ({
  item,
  useCountLeftBadge
}) => <Base data-sentry-element="Base" data-sentry-component="ItemRow" data-sentry-source-file="index.tsx">
    <ItemLeftWrapper data-sentry-element="ItemLeftWrapper" data-sentry-source-file="index.tsx">
      <Thumbnail data-sentry-element="Thumbnail" data-sentry-source-file="index.tsx">
        <ItemThumbnail item={item} data-sentry-element="ItemThumbnail" data-sentry-source-file="index.tsx" />
        <>{useCountLeftBadge}</>
      </Thumbnail>
      <ItemLabel data-sentry-element="ItemLabel" data-sentry-source-file="index.tsx">
        <ItemTitle data-sentry-element="ItemTitle" data-sentry-source-file="index.tsx">{item.displayName}</ItemTitle>
        <ItemUseDays data-sentry-element="ItemUseDays" data-sentry-source-file="index.tsx">
          {formatDistanceToNow(new Date(item.dateValidUntil), {
          locale: languageDateLocaleMap[getLocale()]
        })}
        </ItemUseDays>
      </ItemLabel>
    </ItemLeftWrapper>
  </Base>;
export default ItemRow;